import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { FadeLoader } from "react-spinners";

const DiplomiraliDetalj = () => {
  const { id } = useParams();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError(false);

    axios
      .get("https://www.asu.unsa.ba/v2/index.php", {
        params: {
          rest_route: `/wp/v2/pages/${id}`,
          _embed: true,
          _fields: "id,title,content,acf,_embedded",
          acf_format: "standard",
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error("API error:", err?.response?.status, err?.response?.data || err?.message);
        setError(true);
        setData(null);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div
        className="text-center"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <FadeLoader color="#123abc" loading={loading} />
      </div>
    );
  }

  if (error || !data) {
    return <p style={{ padding: 20 }}>Podaci nisu dostupni.</p>;
  }

  return (
    <div className="container drugaSekcija dekanat nastavnik">
      <div className="container dekanat">
        <main role="main" className="container drugaSekcija">
          <div className="row">
            <h1 style={{ color: "black", fontWeight: "normal", fontSize: "2rem" }}>
              {data?.title?.rendered || "—"}
            </h1>

            <div className="col-md-8">
              <div
                dangerouslySetInnerHTML={{ __html: data?.content?.rendered || "" }}
              />
            </div>
          </div>

          <div className="row">
            <hr />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DiplomiraliDetalj;
